import GroupedContent from 'grouped-content';
import fitvids from 'fitvids';

export default class RTE {
  constructor(component) {
    this.el = component.el;
    this.$el = $(this.el);
    this.setupTabs();
    this.resizeVideos();
    fitvids(this.$el, { customSelector: 'iframe' });
  }

  setupTabs() {
    return new GroupedContent(this.$el.get(0), { layout: 'tabs', intelliparse: false });
  }

  resizeVideos() {
    fitvids(this.$el, { customSelector: 'iframe' });

    const videos = $('iframe', this.$el);
    for (let i = 0; i < videos.length; i++) {
      const video = videos[i];
      if (video.hasClass('highlight')) {
        video.parent().addClass('highlight');
      }
    }
  }
}
